import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useIntl } from 'react-intl';
import { Button, Collapse } from 'reactstrap';

import { userIsAdmin, userIsManager } from '../../../helpers/Auth';
import { getInitialOpenOnboardingStep, isOnboardingStepCompleted } from '../../../helpers/Onboarding';

import OnboardingStepHeader from './StepHeader';
import OnboardingSkipButton from './SkipButton';
import VideoShowcase from '../../VideoShowcase';

const OnboardingAddTags = ({ slug }) => {
  const intl = useIntl();

  const [isOpen, setIsOpen] = useState(getInitialOpenOnboardingStep() === slug);

  const isCompleted = isOnboardingStepCompleted(slug);
  const initialOpenStep = getInitialOpenOnboardingStep();

  useEffect(() => {
    if (initialOpenStep === slug) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [slug, initialOpenStep]);

  if (!(userIsAdmin() || userIsManager())) {
    return null;
  }

  return (
    <div className={classnames('onboarding-step', { 'onboarding-step-next': initialOpenStep === slug })}>
      <OnboardingStepHeader
        isOpen={isOpen}
        handleOpen={setIsOpen}
        title={intl.formatMessage({ defaultMessage: 'Upload or import and add your tag' })}
        subtitle={intl.formatMessage({ defaultMessage: 'From inside any Collection, drag and drop files from your computer or import them from Dropbox, Box, or Google Drive. Add tags while uploading. AI tagging will run in the background to help!' })}
        isCompleted={isCompleted}
      />
      <Collapse isOpen={isOpen} className="onboarding-step-collapse">
        <div>
          <div className="onboarding-step-collapse-video">
            <VideoShowcase
              video="https://player.vimeo.com/video/1069796309?h=289ffa4dab&badge=0&byline=0&title=0"
              thumbnail="https://i.vimeocdn.com/video/1998191400-12b02eb5b80d6431a4bacde022ffc520cad7d263bbe9eee8244aae700ef6d4cd-d?mw=800&mh=450"
              title={intl.formatMessage({ defaultMessage: 'Add tags to your files' })}
            />
          </div>
          <div className="onboarding-step-collapse-buttons">
            <div>
              <Button
                color="link"
                tag="a"
                href="https://help.stockpress.co/en/articles/5937739-uploading-or-importing-files-and-folders-into-your-workspace"
                target="_blank"
              >
                <i className="far fa-book mr-1" />
                {intl.formatMessage({ defaultMessage: 'Find out more' })}
              </Button>
            </div>
            <div>
              <OnboardingSkipButton slug={slug} isCompleted={isCompleted} />
            </div>
          </div>
        </div>
      </Collapse>
    </div>
  );
};

OnboardingAddTags.propTypes = {
  slug: PropTypes.string.isRequired,
};

export default OnboardingAddTags;
